import React, { useState } from "react";
// import "../../scss/components/_forward-email-modal.scss";

const ForwardEmailModal = ({ isOpen, onClose, onForward, originalRecipient }) => {
  const [toEmails, setToEmails] = useState([""]);
  const [ccEmails, setCcEmails] = useState([""]);
  const [bccEmails, setBccEmails] = useState([""]);
  const [isSending, setIsSending] = useState(false);
  const [toEmailErrors, setToEmailErrors] = useState([]);
  const [ccEmailErrors, setCcEmailErrors] = useState([]);
  const [bccEmailErrors, setBccEmailErrors] = useState([]);

  // Add new email input field
  const addToEmail = () => {
    setToEmails([...toEmails, ""]);
    setToEmailErrors([...toEmailErrors, ""]);
  };

  const addCcEmail = () => {
    setCcEmails([...ccEmails, ""]);
    setCcEmailErrors([...ccEmailErrors, ""]);
  };

  const addBccEmail = () => {
    setBccEmails([...bccEmails, ""]);
    setBccEmailErrors([...bccEmailErrors, ""]);
  };

  // Remove email input field
  const removeToEmail = (index) => {
    const newEmails = toEmails.filter((_, i) => i !== index);
    const newErrors = toEmailErrors.filter((_, i) => i !== index);
    setToEmails(newEmails.length === 0 ? [""] : newEmails);
    setToEmailErrors(newErrors.length === 0 ? [""] : newErrors);
  };

  const removeCcEmail = (index) => {
    const newEmails = ccEmails.filter((_, i) => i !== index);
    const newErrors = ccEmailErrors.filter((_, i) => i !== index);
    setCcEmails(newEmails.length === 0 ? [""] : newEmails);
    setCcEmailErrors(newErrors.length === 0 ? [""] : newErrors);
  };

  const removeBccEmail = (index) => {
    const newEmails = bccEmails.filter((_, i) => i !== index);
    const newErrors = bccEmailErrors.filter((_, i) => i !== index);
    setBccEmails(newEmails.length === 0 ? [""] : newEmails);
    setBccEmailErrors(newErrors.length === 0 ? [""] : newErrors);
  };

  // Update email value with real-time validation
  const updateToEmail = (index, value) => {
    const newEmails = [...toEmails];
    newEmails[index] = value;
    setToEmails(newEmails);

    // Validate as user types (only if they've started typing)
    const newErrors = [...toEmailErrors];
    if (value.trim() !== "") {
      newErrors[index] = isValidEmail(value) ? "" : "Please provide a valid email address";
    } else {
      newErrors[index] = "";
    }
    setToEmailErrors(newErrors);
  };

  const updateCcEmail = (index, value) => {
    const newEmails = [...ccEmails];
    newEmails[index] = value;
    setCcEmails(newEmails);

    // Validate as user types (only if they've started typing)
    const newErrors = [...ccEmailErrors];
    if (value.trim() !== "") {
      newErrors[index] = isValidEmail(value) ? "" : "Please provide a valid email address";
    } else {
      newErrors[index] = "";
    }
    setCcEmailErrors(newErrors);
  };

  const updateBccEmail = (index, value) => {
    const newEmails = [...bccEmails];
    newEmails[index] = value;
    setBccEmails(newEmails);

    // Validate as user types (only if they've started typing)
    const newErrors = [...bccEmailErrors];
    if (value.trim() !== "") {
      newErrors[index] = isValidEmail(value) ? "" : "Please provide a valid email address";
    } else {
      newErrors[index] = "";
    }
    setBccEmailErrors(newErrors);
  };

  // Validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

  // Handle forward submission
  const handleForward = async () => {
    // Filter out empty emails and validate
    const validToEmails = toEmails.filter(email => email.trim() !== "");
    const validCcEmails = ccEmails.filter(email => email.trim() !== "");
    const validBccEmails = bccEmails.filter(email => email.trim() !== "");

    // Validation
    if (validToEmails.length === 0) {
      alert("Please enter at least one recipient email address");
      return;
    }

    // Validate email formats
    const invalidToEmails = validToEmails.filter(email => !isValidEmail(email));
    const invalidCcEmails = validCcEmails.filter(email => !isValidEmail(email));
    const invalidBccEmails = validBccEmails.filter(email => !isValidEmail(email));

    if (invalidToEmails.length > 0) {
      alert(`Invalid email format in To field: ${invalidToEmails.join(", ")}`);
      return;
    }

    if (invalidCcEmails.length > 0) {
      alert(`Invalid email format in CC field: ${invalidCcEmails.join(", ")}`);
      return;
    }

    if (invalidBccEmails.length > 0) {
      alert(`Invalid email format in BCC field: ${invalidBccEmails.join(", ")}`);
      return;
    }

    setIsSending(true);
    try {
      await onForward(validToEmails, validCcEmails, validBccEmails);
      // Reset form
      setToEmails([""]);
      setCcEmails([""]);
      setBccEmails([""]);
      onClose();
    } catch (error) {
      console.error("Forward error:", error);
    } finally {
      setIsSending(false);
    }
  };

  const handleClose = () => {
    setToEmails([""]);
    setCcEmails([""]);
    setBccEmails([""]);
    setToEmailErrors([]);
    setCcEmailErrors([]);
    setBccEmailErrors([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="forward-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Forward Email</h2>
          <button className="close-btn" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="original-recipient">
            <strong>Original Recipient:</strong> {originalRecipient}
          </div>

          {/* To Emails Section */}
          <div className="email-section">
            <label className="section-label">
              <strong>To:</strong> <span className="required">*</span>
            </label>
            {toEmails.map((email, index) => (
              <div key={`to-${index}`} className="email-input-wrapper">
                <div className="email-input-row">
                  <input
                    type="email"
                    className={`email-input ${toEmailErrors[index] ? 'input-error' : ''}`}
                    placeholder="Enter email address"
                    value={email}
                    onChange={(e) => updateToEmail(index, e.target.value)}
                  />
                  {toEmails.length > 1 && (
                    <button
                      className="btn-remove"
                      onClick={() => removeToEmail(index)}
                      title="Remove"
                    >
                      ×
                    </button>
                  )}
                </div>
                {toEmailErrors[index] && (
                  <span className="error-message">{toEmailErrors[index]}</span>
                )}
              </div>
            ))}
            <button className="btn-add" onClick={addToEmail}>
              + Add Another Recipient
            </button>
          </div>

          {/* CC Emails Section */}
          <div className="email-section">
            <label className="section-label">
              <strong>CC:</strong>
            </label>
            {ccEmails.map((email, index) => (
              <div key={`cc-${index}`} className="email-input-wrapper">
                <div className="email-input-row">
                  <input
                    type="email"
                    className={`email-input ${ccEmailErrors[index] ? 'input-error' : ''}`}
                    placeholder="Enter email address (optional)"
                    value={email}
                    onChange={(e) => updateCcEmail(index, e.target.value)}
                  />
                  {ccEmails.length > 1 && (
                    <button
                      className="btn-remove"
                      onClick={() => removeCcEmail(index)}
                      title="Remove"
                    >
                      ×
                    </button>
                  )}
                </div>
                {ccEmailErrors[index] && (
                  <span className="error-message">{ccEmailErrors[index]}</span>
                )}
              </div>
            ))}
            <button className="btn-add" onClick={addCcEmail}>
              + Add CC Recipient
            </button>
          </div>

          {/* BCC Emails Section */}
          <div className="email-section">
            <label className="section-label">
              <strong>BCC:</strong>
            </label>
            {bccEmails.map((email, index) => (
              <div key={`bcc-${index}`} className="email-input-wrapper">
                <div className="email-input-row">
                  <input
                    type="email"
                    className={`email-input ${bccEmailErrors[index] ? 'input-error' : ''}`}
                    placeholder="Enter email address (optional)"
                    value={email}
                    onChange={(e) => updateBccEmail(index, e.target.value)}
                  />
                  {bccEmails.length > 1 && (
                    <button
                      className="btn-remove"
                      onClick={() => removeBccEmail(index)}
                      title="Remove"
                    >
                      ×
                    </button>
                  )}
                </div>
                {bccEmailErrors[index] && (
                  <span className="error-message">{bccEmailErrors[index]}</span>
                )}
              </div>
            ))}
            <button className="btn-add" onClick={addBccEmail}>
              + Add BCC Recipient
            </button>
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-cancel"
            onClick={handleClose}
            disabled={isSending}
          >
            Cancel
          </button>
          <button
            className="btn btn-forward"
            onClick={handleForward}
            disabled={isSending}
          >
            {isSending ? "Forwarding..." : "Forward Email"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForwardEmailModal;